export default __webpack_public_path__ + "media/images/about_us/confra-tabas-2022-d4f58ee1db221a7ba4c017745670c024.png";